<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors"
      layout="nolabel"
    />
    <div class="form-group">
      <input type="submit" :value="$t('Reset Password')" class="reg-btn" />
    </div>
  </form>
</template>

<script>
import { FormMixin } from "stylemix-base";

export default {
  name: "Reset",

  mixins: [FormMixin],

  data() {
    return {
      model: window.RESET_FORM.data,
    };
  },

  created() {
    this.setFields(window.RESET_FORM.fields);
    let keys = ["email", "password", "password_confirmation"];
    keys.forEach((key) => {
      let field = this.fields.get(key);
      field.placeholder = this.$t(field.label);
    });
  },

  methods: {
    submit() {
      this.errors.clear();
      this.$http
        .post("auth/password/reset", this.model)
        .then((response) => {
          this.$toast.success(this.$t("Your password successfully changed"));
        })
        .catch((rejection) => {
          if (rejection.response && rejection.response.status === 422) {
            this.$toast.error(rejection.response.data.message);
            this.setValidationErrors(rejection.response.data.errors);
          }
        });
    },
  },
};
</script>
